module.exports = {
  headers: [
    { text: "Opciones", value: "opciones", sortable: false },
    { text: "Usuario", value: "usuario.nombre", sortable: true },
    { text: "Cliente", value: "persona.nombre", sortable: true },
    { text: "Fecha", value: "entregaAt", sortable: true },
    { text: "Total", value: "total", sortable: true },
    { text: "Pagado", value: "pagado", sortable: false },
    { text: "Entrega", value: "entrega", sortable: false },
    { text: "Estado", value: "estado", sortable: true },
  ],
  headersPedido: [
    { text: "Opciones", value: "opciones", sortable: false },
    { text: "Usuario", value: "usuario.nombre", sortable: true },
    { text: "Cliente", value: "persona.nombre", sortable: true },
    { text: "Fecha Entrega", value: "entregaAt", sortable: true },
    { text: "Total", value: "total", sortable: true },
    { text: "Pagado", value: "pagado", sortable: false },
    { text: "Entrega", value: "entrega", sortable: false },
  ],
  cabeceraDetalles: [
    { text: "Borrar", value: "borrar", sortable: false },
    { text: "Artículo", value: "articulo", sortable: false },
    { text: "Cantidad", value: "cantidad", sortable: false },
    { text: "Unidad", value: "unidad", sortable: false },
    { text: "Precio", value: "precio", sortable: false },
    { text: "Descripcion", value: "descripcion", sortable: false },
    { text: "Sub Total", value: "subtotal", sortable: false },
  ],
  cabeceraArticulos: [
    { text: "Seleccionar", value: "seleccionar", sortable: false },
    { text: "Código", value: "codigo", sortable: false },
    { text: "Nombre", value: "nombre", sortable: true },
    { text: "Categoría", value: "categoria.nombre", sortable: true },
    { text: "Stock", value: "stock", sortable: false },
    { text: "Precio Venta", value: "precio_venta", sortable: false },
    { text: "Descripción", value: "descripcion", sortable: false },
    { text: "Estado", value: "estado", sortable: false },
  ],
  unidades: [
    { text: "Bulto", value: "Bulto" },
    { text: "Atado", value: "Atado" },
    { text: "Kilo", value: "Kilo" },
    { text: "Gramos", value: "Gramos" },
    { text: "Unidad", value: "Unidad" },
  ],
  comprobantes: ["BOLETA", "FACTURA", "TICKET", "GUIA"],
  negocios: [
    { text: "Almacén", value: 1 },
    { text: "Distribución", value: 2 },
  ],
  modoChart: {
    modouno: "bar",
    mododos: "column",
    modotres: "area",
    modocuatro: "areaspline",
    modopedido: "pie",
    modopedido2: "",
  },
};
